import React from 'react';
import styles from './ActionToolbar.module.css';
import { EditIcon, TrashIcon, RotateIcon } from '../Icon';
import Button from '../Button/Button';

const ActionToolbar = ({
    isVisible,
    onEditGeometry,
    onDelete,
    onNSPDUpdate,
    hasCadastralNumber = false,
    hasNSPD = false,
    extraActions = null
}) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles.actionToolbarContainer}>
            <div className={styles.actionToolbar}>
                <Button
                    variant="icon"
                    onClick={onEditGeometry}
                    title="Редактировать геометрию"
                    className={styles.toolbarButton}
                >
                    <EditIcon size={20} />
                </Button>
                {hasCadastralNumber && hasNSPD && (
                    <Button
                        variant="icon"
                        onClick={onNSPDUpdate}
                        title="Обновить данные из НСПД"
                        className={styles.toolbarButton}
                    >
                        <RotateIcon size={20} />
                    </Button>
                )}
                <Button
                    variant="icon"
                    onClick={onDelete}
                    title="Удалить объект"
                    className={`${styles.toolbarButton} ${styles.deleteButton}`}
                >
                    <TrashIcon size={20} />
                </Button>
            </div>
            {extraActions}
        </div>
    );
};

export default ActionToolbar;